import React from 'react'
import { CardGroup, Card, Row, Col, } from 'react-bootstrap';
import '../mysass.scss';
import { MDBRow } from 'mdb-react-ui-kit';


const Cities = () => {
  return (
<>


<div className='anchorscities' id='cities' style={{textAlign:'center',fontSize:'16px'}}>
      Scroll down for some cities of <b>KOSOVO</b>:
    </div>

    <br></br>

<MDBRow className='m-0 row-cols-1 row-cols-md-4 g-1'>
<CardGroup className="m-0 d-block" >
          <Card className=" m-2 border-0 shadow" style={{padding:'1rem',borderRadius:'50'}}>
            <Row>
              <Col>
                <Card.Img className='placesimage' src="image3.jpg"  />
              </Col>
              <Col>
                <Card.Body className='citiesbody'>
                <Card.Title className='placestitle' 
                style={{fontFamily:'Black Ops One, cursive'}}>Prishtina</Card.Title>
                <Card.Text>
                  <h6 className='citiesbiography'>
                    Enjoy the city's cultural history and modern lifestyle: try the local dishes 
                    or go party in the numerous bars and clubs.To see the most important sights, 
                    a walk is recommended, which should perhaps begin in Dardania, past a gigantic 
                    picture ans statue of US President Bill Clinton, the Grand Hotel, and follow 
                    Nena Tereze Street to the Skenderbeg Monument and the government building . 
                    In the old town with its narrow streets you will find several impressive mosques 
                    and you can drift through the markets and cafes. Also, don't miss the city's 
                    Ethnographic Museum, located in the old town. Perhaps you can consider a detour 
                    to Dragodan or Arberi, where the city  
                    is particularly attractive. The Gërmia Park is also worth a visit. 
                    With its lake-like outdoor pool, it is a popular attraction for families 
                    and young people. Families from Prishtina love to spend their free time together 
                    in this park, which is ideal for swimming in summer, fishing in autumn and 
                    opportunities for walks in the fresh air all year round.
                    </h6>
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>


        <CardGroup className="m-0 d-block">
          <Card className="m-2 border-0 shadow" style={{padding:'1rem',borderRadius:'50'}}>
            <Row>
            <Col>
                <Card.Img className='placesimage' src="image4.jpg"  />
              </Col>
              <Col>
                <Card.Body className='citiesbody'>
                <Card.Title className='placestitle' 
                style={{fontFamily:'Black Ops One, cursive',}}>Prizreni</Card.Title>
                <Card.Text>
                  <h6 className='citiesbiography'>
                    Prizren "City of Lilies" is located in the south of Kosovo. The picturesque 
                    buildings of the old town were built in the Ottoman and Byzantine styles. 
                    Prizren borders on the large municipalities of Gjakova, Rahovec, Mamusha, 
                    Suhareka and Shtrpce. As the cultural capital of Kosovo with many summer 
                    festivals and the most beautiful city center in the country, Prizren has what 
                    it takes to become an interesting travel destination for foreign tourists. 
                    Prizren is also called the "city of lilies": they grow unchecked in the alleys, 
                    on the bridges and in the bazaars, wherever there is a piece of ground. The fortress hill 
                    of the fortress of Prizren, east of the old town, has long been a strategically 
                    important base and offers visitors a panoramic view of the city, plains and 
                    mountain ranges. The fortress walls enclose an area of ​​around 1.5 hectares and 
                    give the fortress an egg-shaped appearance in north-south expansion. 
                    The fortress is 525 meters above sea level.</h6>
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>


        <CardGroup className="m-0 d-block">
          <Card className="m-2 border-0 shadow" style={{padding:'1rem',borderRadius:'50'}}>
            <Row>
              <Col>
                <Card.Img className='placesimage' src="image5.jpg"  />
              </Col>
              <Col>
                <Card.Body className='citiesbody'> 
                <Card.Title className='placestitle' 
                style={{fontFamily:'Black Ops One, cursive'}}>Gjakova</Card.Title>
                <Card.Text>
                  <h6 className='citiesbiography'>
                    Gjakova is the seventh largest city in Kosovo with a population of just under 
                    40,000 and is located in the southwest of the country near the border with Albania.
                    Gjakova is located right at the entrance of the Erenik Valley, where the Krena 
                    river flows from the north into the Erenik mountain river. Founded in the 15th 
                    century, the city is now characterized by many historic buildings and large 
                    industrial areas. The Krena flows after a few kilometers above the Drin Gorge 
                    into the White Drin, the longest river in Kosovo. Eight kilometres in it is 
                    located The Radoniq Reservoir north of the city behind a few hills.
                    Çarshia e Vjetër is one of the city's biggest attractions in Gjakova vacations. 
                    The Old Bazaar (Çarshija e vjetër) was the heart of the economy in Gjakova. 
                    This area of the city of trade and goods included villages around the 
                    municipality of Gjakova, the Junik zone and the Gjakova highlands on the 
                    border with Kosovo and Albania.
                    </h6>
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>


        <CardGroup className="m-0 d-block">
          <Card className="m-2 border-0 shadow" style={{padding:'1rem',borderRadius:'50'}}>
            <Row>
            <Col>
                <Card.Img className='placesimage' src="peja.jpg"  />
              </Col>
              <Col>
                <Card.Body className='citiesbody'>
                <Card.Title className='placestitle' 
                style={{fontFamily:'Black Ops One, cursive'}}>Peja</Card.Title>
                <Card.Text>
                  <h6 className='citiesbiography'>
                  Peja is a city in western Kosovo. The city has an extraordinary history with a 
                  rich cultural heritage and rare natural beauty. Peja is located along the 
                  Bistrica e Pejës river. With almost 96,000 inhabitants, it is the fourth 
                  largest city in the country. For most visitors, the real reason to visit is to 
                  use the city as a starting point for some wonderful excursions into the 
                  mountains and the spectacular, nearby Rugova Valley. The Boge ski area is part 
                  of the Peja municipality as well.As you cross the Rugova Valley, you will notice 
                  its beauty and undiscovered treasures. The Peja River has its source in the 
                  "Accursed Mountains" and flows into the longest river in Kosovo, the White Drin. 
                  The Drini spring is also located in the municipality of Peja in the village of 
                  Radavc with beautiful waterfalls. The climate in Peja is continental.</h6>
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>
  
        <CardGroup className="m-0 d-block">
          <Card className="m-2 border-0 shadow" style={{padding:'1rem',borderRadius:'50'}}>
            <Row>
              <Col>
                <Card.Img className='placesimage' src="ferizaj.jpg"  />
              </Col>
              <Col>
                <Card.Body className='citiesbody'>
                <Card.Title className='placestitle' 
                style={{fontFamily:'Black Ops One, cursive'}}>Ferizaj</Card.Title>
                <Card.Text>
                  <h6 className='citiesbiography'>
                  Ferizaj is a city in the south of Kosovo and the capital of the municipality of 
                  the same name and the Ferizaj district. Ferizaj is a symbol of religious tolerance: 
                  the mosque and church are located next to each other in the same courtyard in the 
                  city center.Ferizaj is located at 573 meters above sea level at the eastern foot of 
                  the Sharr Mountains in the valley of the Lepenci River, which drains this region of 
                  Kosovo to the Aegean Sea. The city is about halfway between Pristina and Skopje, 
                  about 40 km north of the border with North Macedonia. The urban area covers around 
                  345 km² and has almost no elevations. While the agriculturally used Kosovo valley 
                  opens up in the north, the first foothills of the Sharr Mountains, which are densely 
                  forested, rise to the west of the city. With 42,000 inhabitants, it is the sixth 
                  largest city in the country.
                    </h6>
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>


        <CardGroup className="m-0 d-block">
          <Card className="m-2 border-0 shadow" style={{padding:'1rem',borderRadius:'50'}}>
            <Row>
            <Col>
                <Card.Img className='placesimage' src="gjilan.jpg"  />
              </Col>
              <Col>
                <Card.Body className='citiesbody'>
                <Card.Title className='placestitle' 
                style={{fontFamily:'Black Ops One, cursive'}}>Gjilani</Card.Title>
                <Card.Text>
                  <h6 className='citiesbiography'>
                  Gjilan also Gjilani is a municipality in the Anamorava region of Kosovo. It is one 
                  of the largest municipalities in the country. Its geographical location provides 
                  good links to other centres of Kosovo and the region.
                  The exact founding year of Gjilan city has not been precisely defined. In the 17th 
                  century, Evlia mentions Elebija Gjilan, but with the name Morava, as Cadillac in 
                  the Sandzak of Vushtrri. Vlia Elebija writes, among other things, that "seventeen 
                  days' journey from Constantinople (today's Istanbul) to Novo Brdo leads through 
                  Vraja, Krivareka (Egridere) and Morava (Gjilan)." Gjilan is located in the eastern 
                  part of Kosovo and is one of the seven largest municipalities in Kosovo. 
                  Since the war in the 1990s, it has also been the centre of the region.
                  According to the 2011 census, the municipality of Gjilan has a population of more than 90,000.</h6>
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>


        <CardGroup className="m-0 d-block">
          <Card className="m-2 border-0 shadow" style={{padding:'1rem',borderRadius:'50'}}>
            <Row>
              <Col>
                <Card.Img className='placesimage' src="mitrovica.jpg"  />
              </Col>
              <Col>
                <Card.Body className='citiesbody'>
                <Card.Title className='placestitle' 
                style={{fontFamily:'Black Ops One, cursive'}}>Mitrovica</Card.Title>
                <Card.Text>
                  <h6 className='citiesbiography'>
                  Mitrovica is a city in northern Kosovo. The strategically 
                  favorable location at the confluence of two rivers meant that the current 
                  location of Mitrovica was already settled in prehistoric times. This fact is 
                  proven by numerous finds that date from the Neolithic Age.In ancient times, 
                  the Illyrian tribe of the Dardans lived here. During excavations in and around 
                  Mitrovica, an Illyrian necropolis, several statues from the period were discovered. 
                  It is believed that Dardania's economy was primarily based on agriculture and 
                  livestock. In addition, remnants of metal slag from this time were found, 
                  which are the oldest evidence of mining in Kosovo.After the Kosovo war in 1999, 
                  the city was divided into a southern part with an almost exclusively Albanian 
                  population and a northern part with a predominantly 
                  Serbian population. The two parts of the city are 
                  connected by two road bridges and a footbridge over the river Ibër. In Mitrovica, 
                  the Ibër takes on the Sitnica coming from the south.
                    </h6>
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>


        <CardGroup className="m-0 d-block">
          <Card className="m-2 border-0 shadow" style={{padding:'1rem',borderRadius:'50'}}>
            <Row>
            <Col>
                <Card.Img className='placesimage' src="podujeva.jpg"  />
              </Col>
              <Col>
                <Card.Body className='citiesbody'>
                <Card.Title className='placestitle' 
                style={{fontFamily:'Black Ops One, cursive'}}>Podujeva</Card.Title>
                <Card.Text>
                  <h6 className='citiesbiography'>
                  Podujeva or Besiana is located in the northeast of Kosovo, on the border with Serbia. 
                  The Llap flows through Podujeva. The region around the city of Llap is named after 
                  this river.In the vicinity of the city is the Batllava reservoir, built in the 
                  sixties , which was built for the supply of drinking water and which still provides 
                  drinking water to the municipalities of Podujeva and Pristina to this day. 
                  In summer it is a popular bathing and fishing lake for people from all over 
                  the country and is also popular with tourists on their Kosovo vacation.
                  Lake Batllava is one of the largest lakes in the eastern part of Kosova. 
                  It is mainly fed by the small Batllava river, which flows into the Lap a few 
                  kilometers below the dam. The name Batllava comes from the nearby village of 
                  Batllava. There are a total of 76 villages in the municipality, their area is 
                  663 km².
                  </h6>
                </Card.Text>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </CardGroup>
        </MDBRow>


        



</>
  )
}

export default Cities